// extracted by mini-css-extract-plugin
export var icon = "_55-1";
export var subtext = "_55-0";